import { ref, readonly, computed, unref } from 'vue';

const FILTER_SECTION_HEIGHT = 61;
const DROPDOWN_BOTTOM_OFFSET = 20;

const DROPDOWN_WITH_SEARCH_MAX_HEIGHT = 410;
const DROPDOWN_WITHOUT_SEARCH_MAX_HEIGHT = 362;

// Global refs that can be shared across components
const searchResultsContainer = ref(null);
const searchResults = ref([]);

export function useSearchResultsContainer() {
  const setContainer = (element) => {
    searchResultsContainer.value = element;
  };

  const setResults = (results) => {
    searchResults.value = results;
  };

  const getContainerHeight = (showSearch) => {
    // fallback
    if (!searchResultsContainer.value) {
      return Math.max(0, DROPDOWN_WITHOUT_SEARCH_MAX_HEIGHT - FILTER_SECTION_HEIGHT - DROPDOWN_BOTTOM_OFFSET);
    }

    const dynamicDropdownHeight =
      searchResultsContainer.value.offsetHeight - FILTER_SECTION_HEIGHT - DROPDOWN_BOTTOM_OFFSET;

    if (unref(showSearch)) {
      return Math.max(0, Math.min(dynamicDropdownHeight, DROPDOWN_WITH_SEARCH_MAX_HEIGHT));
    }
    return Math.max(0, Math.min(dynamicDropdownHeight, DROPDOWN_WITHOUT_SEARCH_MAX_HEIGHT));
  };

  const hasResults = computed(() => searchResults.value.length > 0);
  const resultsCount = computed(() => searchResults.value.length);

  return {
    searchResultsContainer: readonly(searchResultsContainer),
    searchResults: readonly(searchResults),
    setContainer,
    setResults,
    getContainerHeight,
    hasResults,
    resultsCount,
  };
}
